import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContentServiceService } from 'src/app/service/content-service.service';
import { Router } from '@angular/router';
import { PortalService } from 'src/app/service/portal.service';

@Component({
  selector: 'app-all-games',
  templateUrl: './all-games.component.html',
  styleUrls: ['./all-games.component.css']
})
export class AllGamesComponent implements OnInit {
  //public games = Game;
  showModalBox: boolean = false;
  discrib: boolean = false;
  allGamesData: any;
  discrb: string;

  constructor(private contentService: ContentServiceService,
    private portalService: PortalService,
    private _router: Router) { }

  ngOnInit(): void {
    this.getAllGamesData()

    if (sessionStorage.getItem('isSubscribed') == '0') {
      this.showModal();
      console.log('isSubscribed=========', sessionStorage.getItem('isSubscribed') == '0');

    }
  }

  showModal() {
    console.log("click");
    this.showModalBox = true
  }
  closeModal() {
    console.log("click");
    this._router.navigateByUrl('/lp')
    this.showModalBox = false;
  }
  discribModal(i, dis) {
    this.discrib = true;
    this.discrb = dis
  }
  closedis() {
    this.discrib = false;
  }




  getAllGamesData() {
    let endpoint = "portal/portalAllGames";
    let data = {
      "data": {
        "portalid": environment.portalid,
      }
    }

    this.contentService.getContentById(data, endpoint)
      .then(response => {
        if (response['success']) {
          console.log("Success..", response)
          this.allGamesData = response['data']['serviceContent'][0]['content'];
          console.log("allGamesData", this.allGamesData);
        }
      })
      .catch(error => {
        console.log("Error", error);
        //this._router.navigate(['/content-management/portal'])
      })

  }

  //downloadLog   this
  downloadLog(contentName) {
    this.portalService.downloadLogEntry(contentName)
  }

}
